export default __webpack_public_path__ + "static/2463-472bc57d8c6ad9b7cd3d9cae1bd8d94f.gif";